module.exports = __webpack_public_path__ + "static/img/eco-protection-04.d06576f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/eco-protection/eco-protection-04.jpg
// module id = pSw7
// module chunks = 96